import { Alert } from '@mui/material'

export const ActionDrawerAlert = ({ message }: { message: string }) => (
    <Alert variant="outlined" severity="error" sx={{ py: 0 }}>
        {message}
    </Alert>
)
